import Vue from 'vue';
import { i18n } from '@/services/i18n';
import '@/i18n/dateLocale';

import {AxiosPlugin} from '@/axio-plugin';
import {LoggerPlugin} from '@/logger';
import BootstrapVue from 'bootstrap-vue';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import App from './App.vue';
import router from './router';

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(AxiosPlugin);
Vue.use(LoggerPlugin);
Vue.use(Antd);

export { i18n };

declare module 'vue/types/options' {
}

function mountApp() {
  new Vue({
    router,
    render: (h) => h(App),
    i18n,
  }).$mount('#app');
}

mountApp();
